var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelTruckAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5C6 19.3284 5.32843 20 4.5 20C3.67157 20 3 19.3284 3 18.5C3 17.6716 3.67157 17 4.5 17C5.32843 17 6 17.6716 6 18.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.5C21 19.3284 20.3284 20 19.5 20C18.6716 20 18 19.3284 18 18.5C18 17.6716 18.6716 17 19.5 17C20.3284 17 21 17.6716 21 18.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8 4.44772 8.44771 4 9 4H11C11.5523 4 12 4.44772 12 5H17C19.2091 5 21 6.79086 21 9C21 11.2091 19.2091 13 17 13H21C21.5523 13 22 13.4477 22 14V16.8411C21.4625 16.0328 20.5435 15.5 19.5 15.5C18.4565 15.5 17.5375 16.0328 17 16.8411C16.4625 16.0328 15.5435 15.5 14.5 15.5C13.4565 15.5 12.5375 16.0328 12 16.8411C11.4625 16.0328 10.5435 15.5 9.5 15.5C8.45651 15.5 7.53746 16.0328 7 16.8411C6.46254 16.0328 5.54349 15.5 4.5 15.5C3.45651 15.5 2.53746 16.0328 2 16.8411V14C2 13.4477 2.44772 13 3 13H7C4.79086 13 3 11.2091 3 9C3 6.79086 4.79086 5 7 5H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTruckAlt);
export default __webpack_public_path__ + "static/media/fuel-truck-alt.b57c49066a2469e983cd836e0a765da4.svg";
export { ForwardRef as ReactComponent };